import { render, staticRenderFns } from "./SfTab.vue?vue&type=template&id=59ef7ed4&"
import script from "./SfTab.vue?vue&type=script&lang=js&"
export * from "./SfTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports